export default __webpack_public_path__ + "static/media/foto03.9a0796d3.png";